import { Link, graphql, navigate } from "gatsby";
import React, { useEffect, useState, useRef } from "react";
import useOnScreen from "../hooks/useOnScreen";
import smoothScrollTo from "../helpers/smoothScrollTo";

const Nav = ({ pathname, headerData }) => {
  const containerEl = useRef(null);
  const isOnScreen = useOnScreen(containerEl);
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    if (pathname !== "/") {
      setIsExpanded(false);
    }
    const limitY = window.innerHeight * 0.125;

    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > limitY && isExpanded === true) {
        setIsExpanded(false);
      } else if (scrollY <= limitY && isExpanded === false) {
        setIsExpanded(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isExpanded]);

  useEffect(() => {
    if (pathname !== "/") {
      setIsExpanded(false);
    } else {
      setIsExpanded(true);
    }
  }, [pathname]);

  const handleScrollClick = (target) => {
    if (pathname === "/") {
      const targetEl = document.querySelector(`.Target-${target}`);
      if (targetEl) {
        smoothScrollTo(targetEl);
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const targetEl = document.querySelector(`.Target-${target}`);
        if (targetEl) {
          smoothScrollTo(targetEl);
        }
      }, 1500);
    }
  };

  const logoText = headerData?.logo_text?.text || "Tech week";
  const links = headerData?.links || [];
  const ctaVisible = headerData?.cta_visible === true;
  const ctaLabel = headerData?.cta_label || "";
  const ctaUrl = headerData?.cta_url || "";

  const renderLinks = () => (
    <ul className="Nav__Links">
      {links.map((link, i) => (
        <li className="Nav__Link" data-is-link key={i}>
          {link.type === "scroll" ? (
            <span
              className="Nav__LinkAppear"
              onClick={() => handleScrollClick(link.url)}
            >
              {link.label}
            </span>
          ) : link.is_external ? (
            <a
              className="Nav__LinkAppear"
              href={link.url}
              target="_blank"
              rel="noreferrer"
            >
              {link.label}
            </a>
          ) : (
            <Link to={link.url} className="Nav__LinkAppear">
              {link.label}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );

  const renderCta = () => {
    if (!ctaVisible) return null;
    return (
      <a className="Nav__Button" data-is-link href={ctaUrl}>
        <div className="Nav__ButtonBorder"></div>
        <div className="Nav__ButtonText">{ctaLabel}</div>
      </a>
    );
  };

  const renderSide = () => (
    <>
      <div className="Nav__Rect">
        <div className="Nav__RectMask">
          <div className="Nav__RectMasked"></div>
        </div>
      </div>
      <h4 className="Nav__Logo" data-is-link>
        <Link to="/">{logoText}</Link>
      </h4>
      {renderLinks()}
      {renderCta()}
    </>
  );

  return (
    <div
      className={`Nav ${isExpanded === true ? "isExpanded" : ""} ${isOnScreen === true ? "onScreen" : ""}`}
      ref={containerEl}
    >
      <div className="Nav__Mask Nav__Mask--Left">{renderSide()}</div>
      <div className="Nav__Mask Nav__Mask--Right">{renderSide()}</div>
    </div>
  );
};

export default Nav;

export const query = graphql`
  fragment Header on PrismicHeader {
    data {
      logo_text {
        text
      }
      links {
        label
        url
        type
        is_external
      }
      cta_label
      cta_url
      cta_visible
    }
  }
`;
